__turbopack_context__.v({
  "className": "cormorant_garamond_c12f99d5-module__4p-ZSa__className",
});
